// // import Image1 from '../assests/banner/'
// import axios from 'axios'
// import Image2 from '../assests/IMG-20230225-WA0044.jpg'
// import Image3 from '../assests/IMG-20230225-WA0051.jpg'
// import Image4 from '../assests/IMG-20230225-WA0059.jpg'
// const Image5= 'https://www.pmindia.gov.in/wp-content/uploads/2021/11/Man-Ki-Baat-HIndi.jpg'

import { useState, useEffect } from 'react';
import axios from 'axios';

const useGetImages = () => {
  const [images, setImages] = useState([]);

  const getCarouselImages = async () => {
    try {
      const { data } = await axios.get("https://api.nigst.surveyofindia.gov.in/viewweb/view_carousel");
      setImages(data?.images || []);
    } catch (err) {
      console.error("Failed to load carousel images", err);
    } 
  };

  useEffect(() => {
    getCarouselImages();
  }, []);

  return  images;
};


export default useGetImages;


// const images=[Image2,Image2,Image3,Image4,Image5]

// export default images;
